import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const Indicators = () => {
    const { chartData } = useHouseholdChartsDataContext();

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }} className="w-100">
            <Card
                title="Média de Pessoas por Família"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averagePeoplePerFamily || 0
                )}
            />
            <Card
                title="Média de Pessoas por Dormitório"
                value={number.formatToBRNumber(
                    chartData?.indicators?.peoplePerRoom || 0
                )}
            />
            <Card
                title="Média de Cômodos por Família"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageRoomsPerFamily || 0
                )}
            />
            <Card
                title="Média de Dormitórios por Cômodo"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageBedsPerRoom || 0
                )}
            />
        </div>
    );
};
